<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="impuesto"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div>

              <div class="w-full" 
                v-if="(role === 7 || role === 8 || role === 3)">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="idCliente" class="w-full">
                    <base-el-select class="w-full" 
                      :options="clientes" 
                      v-model="form.idCliente" 
                      :loading="loadingClientes" 
                      disabled />
                  </el-form-item>
                  <base-button class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
                <el-form-item prop="Name">
                  <el-input
                    disabled
                    class="w-full"
                    v-model="form.Name"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('impuestos.entity_name')}}</label>
              <el-form-item prop="roleId">
                <base-el-select disabled class="w-full" :options="tiposCodigoImpuesto" v-model="form.TaxType" />
              </el-form-item>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('impuestos.TaxRate')}}</label>
                <el-form-item prop="TaxRate">
                  <el-input
                    disabled
                    class="w-full"
                    v-model.number="form.TaxRate"
                    maxlength='9'
                  />
                </el-form-item>
              </div>
            </div>

            <div v-if="isTaxTypeIVA" class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('impuestos.equivalence_surcharge') }}</label>
                <el-form-item prop="EquivalenceSurcharge">
                  <el-input
                    disabled
                    class="w-full"
                    v-model="form.EquivalenceSurcharge"
                    maxlength='9'
                  />
                </el-form-item>
              </div>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="check"
            @click="deleteEntity()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="check"
            @click="restoreEntity()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <Dialog
        :title="$t('impuestos.delete_taxes')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getClients } from '@/services/clients/getClients'
import { getImpuesto } from '@/services/configurations/getImpuesto'
import { i18n } from '@/i18n'
import { deleteTrashImpuesto } from '@/services/trash/deleteTrashImpuesto'
import { restoreTrashImpuesto } from '@/services/trash/restoreTrashImpuesto'
import { Dialog } from 'element-ui'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-impuesto',
  components: {
    DetailLayout,
    Dialog,
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      header: {
        title: i18n.t('trash.impuesto_detail'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'trash/impuestos'
      },
      form: this.getDefaultForm(),
      loadingClientes: false,
      clientes: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation', { entity: i18n.t('impuestos.entity_name').toLowerCase() }),
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposCodigoImpuesto: function () {
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO']
    },
    isTaxTypeIVA: function () {
      return this.form.TaxType === '01'
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const breadcrumbs = []
    
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes=true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
      this.loadingClientes=false
    }

    await this.downloadData(this.id)
    breadcrumbs.push({ path: 'trash/impuestos', name: i18n.t('trash.header') })
    breadcrumbs.push({ path: 'trash/impuestos', name: i18n.t('trash.impuestos') })
    breadcrumbs.push({ path: '', name: this.form.Name })
    this.$store.commit('app/setheaderBreadCrumb', this.form.Name)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    goDetailClient () {
      const id = this.form.idCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteEntity () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idImpuestos: []
        }
        payload.idImpuestos.push(this.id)
        const response = await deleteTrashImpuesto(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreEntity: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idImpuestos: []
        }
        payload.idImpuestos.push(this.id)
        const response = await restoreTrashImpuesto(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        Name: '',
        TaxType: '',
        TaxRate: '',
        idCliente: '',
        EquivalenceSurcharge: ''
      }
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    goBack: function () {
      this.$router.push({ name: 'trash/impuestos' })
    },
    downloadData: async function (id) {
      let res = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idImpuesto: id,
          borrado: true,
        }
        res = await getImpuesto(params)
        this.setEntity(res.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return res
    },
    setEntity: function (res) {
      this.form.id = res.idImpuesto
      this.form.Name = res.Name
      this.form.TaxType = res.TaxType
      this.form.TaxRate = res.TaxRate
      this.form.idCliente = res.idCliente
      this.form.EquivalenceSurcharge = res.EquivalenceSurcharge
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.Name
      this.$store.commit('app/setheaderBreadCrumb', this.form.Name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
